import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';

export class FileSystemListDataService extends DataService<typeof Model.General.Logic.ViewModels.FileSystemSummary, Model.General.Logic.ViewModels.FileSystemSummary, IFileSystemSummary> {
    protected map(entity: Model.General.Logic.ViewModels.FileSystemSummary): IFileSystemSummary {
        return new FileSystemSummaryModel(entity);
    }

    public static make(ctx?: any): FileSystemListDataService {
        return new FileSystemListDataService(ctx, ctx => ctx.FileSystemSummaries);
    }
}

export class FileSystemSummaryModel extends EntityModel<Model.General.Logic.ViewModels.FileSystemSummary, IFileSystemSummary> implements IFileSystemSummary {
    @property<FileSystemSummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
    public id: number;

    @property<FileSystemSummaryModel>(o => o.entity.containerId, (o, value) => o.entity.containerId = value)
    public containerId: string;

    @property<FileSystemSummaryModel>(o => o.entity.filename, (o, value) => o.entity.filename = value)
    public filename: string;

    @property<FileSystemSummaryModel>(o => o.entity.isLatestVersion, (o, value) => o.entity.isLatestVersion = value)
    public isLatestVersion: boolean;

    @property<FileSystemSummaryModel>(o => o.entity.isPublished, (o, value) => o.entity.isPublished = value)
    public isPublished: boolean;

    @property<FileSystemSummaryModel>(o => o.entity.mimeType, (o, value) => o.entity.mimeType = value)
    public mimeType: string;

    @property<FileSystemSummaryModel>(o => o.entity.permissions, (o, value) => o.entity.permissions = value)
    public permissions: string;

    @property<FileSystemSummaryModel>(o => o.entity.size, (o, value) => o.entity.size = value)
    public size: number;

    @property<FileSystemSummaryModel>(o => o.entity.statusMessage, (o, value) => o.entity.statusMessage = value)
    public statusMessage: string;

    @property<FileSystemSummaryModel>(o => o.entity.tags, (o, value) => o.entity.tags = value)
    public tags: string;

    @property<FileSystemSummaryModel>(o => o.entity.title, (o, value) => o.entity.title = value)
    public title: string;

    @property<FileSystemSummaryModel>(o => o.entity.version, (o, value) => o.entity.version = value)
    public version: number;

    @property<FileSystemSummaryModel>(o => o.entity.ownerId, (o, value) => o.entity.ownerId = value)
    public ownerId: number;

    @property<FileSystemSummaryModel>(o => o.entity.ownerUserName, (o, value) => o.entity.ownerUserName = value)
	public ownerUserName: string;

	@property<FileSystemSummaryModel>(o => o.entity.templateId, (o, value) => o.entity.templateId = value)
	public templateId: number;
}



// WEBPACK FOOTER //
// ./src/app/general/document-generation/file-system-list.data.ts